export default "__VITE_ASSET__bc46e76f__"